import Batcher from './Batcher';
import type Fragment from './Fragment';
import { Batch } from './Batch';

export class MutationBatcher extends Batcher {
  createBatch() {
    return new Batch({
      mutate: true,
      reactivelyUpdate: this._options.reactivelyUpdate,
    });
  }

  async mutate(fragment: Fragment): Promise<any> {
    return new Promise((resolve, reject) => {
      this.currentBatch.add(fragment, (data, err) => {
        if (err) return reject(err);

        resolve({ [fragment.name]: data });
      });

      this.checkLimit();
    });
  }
}
